<template>
  <Layout>
    <div v-if="!show_ie">
      <!-- <Appdowload></Appdowload> -->
      <div class="bordertop2">
        <div class="header">
          <HeaderNav name="5"></HeaderNav>
        </div>
        <div class="aboutus">
          <div class="banner-img">
            <img src="https://jiekexuetang.oss-cn-shenzhen.aliyuncs.com/yoga/about.png" />
            <div class="title">
              <h1>关于我们</h1>
              <p>ABOUT KHYoga</p>
            </div>
          </div>
        </div>

        <!--认识我们 start-->
        <div class="know-us container-margin">
          <div class="title">
            <h1>认识我们</h1>
            <p>KNOW US</p>
          </div>
          <div class="content">
            <p>{{aboutus.about_our}}</p>
          </div>
        </div>
        <!--认识我们 end-->
        <!--团队介绍 start-->
        <div class="team-introdution container-margin">
          <div class="title">
            <h1>团队介绍</h1>
            <p>TEAM INTRODUTION</p>
          </div>
          <div class="content teacher-container">
            <div class="swiper-wrapper">
              <!-- <div v-for="teacher in teachers" class="swiper-slide">
                <div class="img">
                  <img :src="'http://'+teacher.avatar" />
                </div>
                <div class="desc">
                  <div class="desc-header">
                    <h1>{{teacher.teacher_name}}</h1>
                    <p>{{teacher.teacher_names}}</p>
                  </div>
                  <div class>
                    <ul>
                      <li>
                        <div class="circle"></div>
                        <span>教师简介</span>
                        <p>{{teacher.teacher_introduction}}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
              <el-carousel indicator-position="outside" class="swiper-slide">
                  <el-carousel-item v-for="teacher in teachers" :key="teacher">
                    <div class="img">
                      <img :src="'http://'+teacher.avatar" />
                    </div>
                    <div class="desc">
                      <div class="desc-header">
                        <h1>{{teacher.teacher_name}}</h1>
                        <p></p>
                      </div>
                      <div class="text">
                        <ul>
                          <li>{{teacher.teacher_introduction}}</li>
                        </ul>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
            </div>
          </div>
        </div>
      </div>

      <!--团队介绍 end-->

      <!--往期课程剪影 start-->
      <div class="past-course-silhouette container-margin">
        <div class="title">
          <h1>往期课程剪影</h1>
          <p>Past Course Silhouette</p>
        </div>
        <!-- <div class="show-imgs">
          <div class="img-box">
            <div class="item-img">
              <img :src="'http://'+pastsilhouette.imgsone" />
            </div>
            <div class="item-img">
              <img :src="'http://'+pastsilhouette.imgstwo" />
            </div>
            <div class="item-img">
              <img :src="'http://'+pastsilhouette.imgstress" />
            </div>
            <div class="item-img">
              <img :src="'http://'+pastsilhouette.imsfive" />
            </div>
          </div>
        </div>-->
        <div class="show-imgs">
          <div class="img-box">
            <el-image
              class="item-imags"
              style="width:24%; height: 340px;"
              :src="'http://'+imgone"
              :preview-src-list="['http://'+imgList]"
            ></el-image>

            <el-image
              class="item-imags"
              :src="'http://'+imgtwo"
              :preview-src-list="['http://'+imgtwoList]"
            ></el-image>

            <el-image
              class="item-imags"
              :src="'http://'+imgthree"
              :preview-src-list="['http://'+imgthreeList]"
            ></el-image>

            <el-image
              class="item-imags"
              :src="'http://'+imgfour"
              :preview-src-list="['http://'+imgfourList]"
            ></el-image>
          </div>
        </div>
      </div>
      <!--往期课程剪影 end-->

      <!--联系我们 start-->
      <div class="contact-us">
        <div class="title">
          <h1>联系我们</h1>
          <p>CONTACT US</p>
        </div>
        <div class="content container-margin">
          <div class="content-text"> 
            <h1>{{aboutus.company_name}}</h1>
            <!--<h2>Shenyang ruoyu health consulting co. LTD</h2>-->
            <div class="bottom">
              <div class="bottom-item">
                <div class="flt icon">
                  <img src="../../assets/phone.png" height="21" width="21" />
                </div>
                <div class="flt">{{aboutus.mobile}}</div>
              </div>
              <div class="bottom-item">
                <div class="flt icon">
                  <img src="../../assets/address.png" height="21" width="21" />
                </div>
                <div class="flt">
                  {{aboutus.address}}
                  <!--<p>53 kunshan middle road, Huanggu District, shenyang city，liaoning province, China (307)</p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--加入我们 end-->
      <FooterDes></FooterDes>
    </div>
    <HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import Appdowload from "../../components/Appdowload";
import HintIE from "../../components/HintIE";
export default {
  components: {
    Appdowload: Appdowload,
    HeaderNav: headernav,
    FooterDes: footer,
    HintIE: HintIE
  },
  data() {
    return {
      aboutus: {},
      pastsilhouette: {},
      teachers: [],
      show_ie: false,
      imgone: "",
      imgList: [],
      imgtwo: "",
      imgtwoList: [],
      imgthree: "",
      imgthreeList: [],
      imgfour: "",
      imgfourList: []
    };
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)
        this.show_ie = true; //不支付IE
    },
    getAboutUs: function() {
      var that = this;
      getData(config.apimethod.getAboutUs, function(res) {
        var data = res.data;
        that.aboutus = data;
      });
    },
    getPastsilhouette: function() {
      var that = this;
      getData(config.apimethod.getPastsilhouette, function(res) {
        var data = res.data;
        // console.log(data);
        that.pastsilhouette = data.imgs;

        that.imgone = data.imgs.imgsone;
        that.imgList.push(data.imgs.imgsone);

        that.imgtwo = data.imgs.imgstwo;
        that.imgtwoList.push(data.imgs.imgstwo);

        that.imgthree = data.imgs.imgstress;
        that.imgthreeList.push(data.imgs.imgstress);

        that.imgfour = data.imgs.imsfive;
        that.imgfourList.push(data.imgs.imsfive);
      });
    },
    getTeacher: function() {
      var that = this;
      getData(config.apimethod.getTeacher, function(res) {
        var data = res.data;
        that.teachers = data.data;
        setTimeout(function() {
          new Swiper(".teacher-container", {
            loop: false,
            autoplay: true,
            speed: 400,
            // 如果需要分页器
            pagination: ".teacher-swiper-pagination"
            // // 如果需要前进后退按钮
            // nextButton: '.swiper-button-next',
            // prevButton: '.swiper-button-prev',
            // // 如果需要滚动条
            // scrollbar: '.swiper-scrollbar',
          });
        }, 1000);
      });
    }
  },
  mounted() {
    this.getAboutUs();
    this.getPastsilhouette();
    this.getTeacher();
    this.isIE();
  }
};
</script>

<style>
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}

.indexnews .ivu-card-body {
  padding: 0;
}

.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
.el-carousel__container {
  height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/pages/about/index.vue